<template lang="pug">
span
  span(@click="modal_open")
    slot(name="activator")
  v-dialog.d-inline(v-model="isModalVisible" persistent max-width="480")
    v-card
      title-bar(dark) DISCONNECT FB ACCOUNT
      v-card-text
        | Are you sure you want to disconnect your account?
        div.my-2.info-box
          | PLEASE NOTE: After disconnecting your account, any synced audiences 
          | will no longer be updated. However, you custom audiences will still 
          | exist in your Facebook ad account.
        v-text-field(autofocus flat :placeholder="typeConfirmPrompt" v-model="typedConfirmString")
      v-card-actions
        v-spacer
        v-btn(flat @click="cancel") Cancel
        v-btn.primary(@click="save" :disabled="shouldDisable") Disconnect
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';

export default {
  components: {
    TitleBar,
  },
  mixins: [Modal],
  data() {
    return {
      confirmKeyword: 'YES',
      typedConfirmString: '',
    };
  },
  computed: {
    typeConfirmPrompt() {
        return `Type ${this.confirmKeyword} to confirm`
    },
    hasConfirmedAction() {
      return this.typedConfirmString !== this.confirmKeyword;
    },
    shouldDisable() {
      return this.hasConfirmedAction;
    },
  },
  methods: {
    async save() {
      this.modal_close();
      this.$emit('confirm-disconnect-fb-account');
      this.typedConfirmString = '';
    },
    cancel() {
      this.typedConfirmString = '';
      this.modal_close();
    },
  },
};
</script>
